import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Header = ({ activePath = "" }) => {
  const [showNavQR, setShowNavQR] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="main-nav">
      <div className="container">
        <Link to="/" className="logo">
          <img src="/assets/logo.jpg" alt="秒应" className="logo-img" />
          秒应
        </Link>
        <div className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <ul className="nav-links">
            <li className={activePath === "/" ? "active" : ""}><Link to="/" onClick={() => { window.scrollTo(0, 0); setMobileMenuOpen(false); }}>首页</Link></li>
            <li><Link to="/#features" onClick={() => setMobileMenuOpen(false)}>核心功能</Link></li>
            <li><Link to="/#scenes" onClick={() => setMobileMenuOpen(false)}>使用场景</Link></li>
            <li><Link to="/#why" onClick={() => setMobileMenuOpen(false)}>差异化优势</Link></li>
            <li><Link to="/#faq" onClick={() => setMobileMenuOpen(false)}>常见问题</Link></li>
            <li className={activePath === "/help" ? "active" : ""}><Link to="/help" onClick={() => setMobileMenuOpen(false)}>操作教程</Link></li>
            <li className={activePath === "/helpcenter" ? "active" : ""}><Link to="/helpcenter" onClick={() => { window.scrollTo(0, 0); setMobileMenuOpen(false); }}>帮助中心</Link></li>
          </ul>
          <div className="nav-menu-actions">
            <button className="nav-menu-btn" onClick={() => { setShowNavQR(!showNavQR); }}>📱 手机版</button>
            {showNavQR && (
              <div className="nav-menu-qr">
                <img src="/assets/code1.8137c5d.jpg" alt="微信小程序码" />
                <span>微信扫码使用</span>
              </div>
            )}
            <a href="https://miaoying.hui51.cn/" target="_blank" rel="noopener noreferrer" className="nav-menu-btn">💻 网页版</a>
          </div>
        </div>
        <div className="nav-right">
          <div className="nav-btns">
            <div className="download-btn-wrapper">
              <button className="nav-btn" onClick={() => setShowNavQR(!showNavQR)}>📱 手机版</button>
              {showNavQR && (
                <div className="qr-popup">
                  <img src="/assets/code1.8137c5d.jpg" alt="微信小程序码" />
                </div>
              )}
            </div>
            <a href="https://miaoying.hui51.cn/" target="_blank" rel="noopener noreferrer" className="nav-btn">💻 网页版</a>
          </div>
          <button className="nav-hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Header;
